import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {
    AreaLight,
    AreaLightParameters,
    constrainTransformTargetableNode,
    TransformMode,
    isNodeWithMatrixArrayLockedTransformParameter,
} from "@cm/template-nodes"
import {Matrix4} from "@cm/math"
import {objectPathPartEquals} from "@app/template-editor/services/scene-manager.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-area-light-inspector",
    templateUrl: "./area-light-inspector.component.html",
    styleUrl: "./area-light-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class AreaLightInspectorComponent extends BaseInspectorComponent<AreaLight> {
    readonly $lightTypePossibilites = signal<SelectionPossibilities<AreaLightParameters["lightType"]>>([
        {value: "Corona", name: "Corona"},
        {value: "Blender", name: "Blender"},
    ])

    onChangedTargeted(value: unknown) {
        if (typeof value === "boolean") {
            const node = this.$node()

            if (!isNodeWithMatrixArrayLockedTransformParameter(node)) return
            const {lockedTransform} = node.parameters

            const {transform: constrainedTransform, target: constrainedTarget} = constrainTransformTargetableNode(
                this.sceneManagerService,
                new Matrix4(lockedTransform),
                {templateNode: node, part: "root"},
                TransformMode.Translate,
            )

            if (constrainedTransform) node.updateParameters({lockedTransform: constrainedTransform.toArray()})
            if (constrainedTarget) node.updateParameters({target: constrainedTarget.toArray()})

            if (value === false) {
                const targetPart = {path: [node], part: "target" as const}
                const rootPart = {path: [node], part: "root" as const}
                const currentSelection = this.sceneManagerService.$selectedObjectPathParts()
                this.sceneManagerService.selectNodes([...currentSelection.filter((p) => !objectPathPartEquals(p, targetPart)), rootPart])
            }
        }
    }
}
